import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  'providedIn': 'root'
})
export class HelperService {

  toCurrency(value: number) {
    return value == null
      ? "0,00"
      : new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
  }

  getUtm(params) {
    let items = ""
    let size = Object.getOwnPropertyNames(params).length;
    let id = 0
    let allowed_utm = ["utm_campaign", "utm_id", "utm_source", "utm_medium", "utm_content"]

    for (let item in params) {
      id = 1 + id

      if (params.hasOwnProperty(item) == false) {
        continue;
      }

      if (allowed_utm.indexOf(item) > -1) {
        if (id < size) {
          items = items + item + "=" + params[item] + "&"
        } else {
          items = items + item + "=" + params[item]
        }
      }
    }

    return items
  }


  queryStringToObject(queryString) {
    let params = ""
   
    if (queryString.startsWith("?")) {
      params =  queryString.slice(1)
    } else {
      params = queryString;
    }

    let combo = params.split("&");
    let res = {};

    combo.forEach(function(ele) {
      const [key, value] = ele.split("=");
      res[key] = decodeURIComponent(value);
    });

    return res;
  }

}